import React, { useState } from "react";

/* Password + confirmation inputs with a show/hide toggle; reads and writes `password` / `password_confirmation`. */
export default function PasswordFields({ idPrefix, form, onChange, label }) {
  const [visible, setVisible] = useState(false);
  const type = visible ? "text" : "password";

  return (
    <>
      <div className="form-grid grid-2">
        <div className="form-group">
          <label htmlFor={`${idPrefix}-password`}>
            {label} <span className="req">*</span>
          </label>
          <input
            type={type}
            id={`${idPrefix}-password`}
            className="form-control"
            autoComplete="new-password"
            placeholder="At least 6 characters"
            maxLength={100}
            value={form.password}
            onChange={(e) => onChange({ password: e.target.value })}
          />
        </div>
        <div className="form-group">
          <label htmlFor={`${idPrefix}-password_confirmation`}>
            Confirm {label} <span className="req">*</span>
          </label>
          <input
            type={type}
            id={`${idPrefix}-password_confirmation`}
            className="form-control"
            autoComplete="new-password"
            maxLength={100}
            value={form.password_confirmation}
            onChange={(e) => onChange({ password_confirmation: e.target.value })}
          />
        </div>
      </div>
      <label className="checkbox-label">
        <input type="checkbox" checked={visible} onChange={(e) => setVisible(e.target.checked)} />
        Show password
      </label>
    </>
  );
}
